import debounce from "lodash.debounce";


export default {
  name: 'DmSearchWindowComp',
  components: {
    DmSelectRecordListCell: require('@/employee/dm/newDebtManagement/dmSelectRecord/dmSelectRecordListCell.vue').default,
  },
  props: {
    records: {
      type: Array,
    },
    showSearchDialog: {
      type: Boolean,
      default: false,
    },
    recordSelectedFunc: {
      type: Function
    },
    saveSearch: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      filteredRecords: [],
      recordsSearchResults: [],
      searchObj: { ConsumerTypeId: '', TenantName: '', Address: '', PropRef: '', SerialNo: '', },
      loadSearchList: false,
      loadSearchListIsDisabled: false,
      advancedSearchResults: [],
      offlineSearchType: 'account',
      offlineSearchText: '',
      lastSelectedRecord: null,
      emptySearch: false,
      isSearched: false,

      filtersDataObj: {
        trim: { readUnread: "0", withNote: false, withAccess: false, disconnected: true, discrepancy: false },
        records: [],
        spotBillEnabled: false,
        filteredRecords: [],
        showDialog: false,
        saveFilters: this.saveFilters
      },
    }
  },
  computed: {    
    filteredRecordsLength: function () {
      return this.filtersDataObj && this.filtersDataObj.filteredRecords ? this.filtersDataObj.filteredRecords.length : 0;
    }
  },
  watch: {
    filteredRecordsLength: function (val) {
      if (!val)
        return;
      this.filteredRecords = [...this.filtersDataObj.filteredRecords];
      this.advancedFilterRecords();
    },
    offlineSearchText: function (val) {
      if (val && this.emptySearch) {
        this.emptySearch = false;
      }

      this.debouncedFunc();
    },
    offlineSearchType: function (val) {
      this.advancedFilterRecords();
    },
    showSearchDialog: function (val) {
      if (val) {
        if (this.advancedSearchResults.length == 1) {
          //this.close();
          return;
        }

        if (this.advancedSearchResults != null && this.advancedSearchResults.length > 0 &&
          this.lastSelectedRecord != null && this.lastSelectedRecord.meterId != null && this.lastSelectedRecord.meterId != '') {
          setTimeout(() => {
            this.scrollToElement(this.lastSelectedRecord.meterId);
          }, 1000);
        }

        if (this.saveSearch) {
          this.loadSearchData();
        }
      }
    }
  },
  created() {
    this.debouncedFunc = debounce(() => {
      this.advancedFilterRecords();
    }, 500);

  },
  mounted() {
    if (this.saveSearch === true)
      this.loadSearchData();

    this.isSearched = false;
    this.filtersDataObj['records'] = this.records;

    this.$root.$on('reset_advanced_search', this.clearAdvancedSearch);
  },
  beforeUnmount() {
    this.debounceFunc.cancel();
  },
  methods: {
    scrollToElement(elem) {
      if (!elem)
        return;

      let e = document.getElementById(elem);

      if (!e)
        return;

      e.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'center' })

    },
    loadSearchData() {
      let t = this.$store.state.dmRecordsSearch;

      if (t != null && t.offlineSearchText != null && t.offlineSearchType != null && t.offlineSearchText != '' && t.offlineSearchType != '') {
        this.offlineSearchType = t.offlineSearchType;
        this.offlineSearchText = t.offlineSearchText;
        this.advancedFilterRecords();
      }
    },
    advancedFilterRecords() {
      this.offlineSearchText = this.offlineSearchText.trim();
      this.isSearched = true;

      if (this.offlineSearchText == null || this.offlineSearchText == '') {
        this.emptySearch = true;
        this.advancedSearchResults = [];
        return;
      }

      this.emptySearch = false;
      this.advancedSearchResults = [...this.records];

      switch (this.offlineSearchType) {
        case 'account':
          this.advancedSearchResults = this.advancedSearchResults.filter(r => r.account != null ? r.account.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().
            includes(this.offlineSearchText.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()) : false);
          break;
        case 'name':
          this.advancedSearchResults = this.advancedSearchResults.filter(r => r.accountName != null ? r.accountName.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().
            includes(this.offlineSearchText.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()) : false);
          break;
        case 'meterRef':
          this.advancedSearchResults = this.advancedSearchResults.filter(r => r.meterRef != null ? r.meterRef.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
            .includes(this.offlineSearchText.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()) : false);
          break;
        case 'plotNo':
          this.advancedSearchResults = this.advancedSearchResults.filter(r => r.plotNo != null ? r.plotNo.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
            .includes(this.offlineSearchText.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()) : false);
          break;
        case 'cell':
          this.advancedSearchResults = this.advancedSearchResults.filter(r => r.cellTelNo != null ? r.cellTelNo.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().
            includes(this.offlineSearchText.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()) : false);
          break;
      }
      this.advancedSearchResults.sort((a, b) => a.account < b.account);
    },
    clearAdvancedSearch() {
      this.lastSelectedRecord = null;
      this.offlineSearchText = '';
      this.offlineSearchType = 'meterNo';
      this.loadSearchList = false;
      this.loadSearchListIsDisabled = false;
      this.advancedSearchResults = [];
      this.isSearched = false;
    },
    recordSelected(item) {
      if (!item) {
        this.lastSelectedRecord = null;
        return;
      }
      
      if (this.saveSearch === true)
        this.saveSearchToStore();

      this.lastSelectedRecord = item;
      //this.clearAdvancedSearch();
      this.recordSelectedFunc(item, this.filtersDataObj);
    },
    getClassBillGroups(id) {
      return 'md-primary';
    },
    close() {
      this.clearAdvancedSearch();
      this.$emit('closeDialog');
    },
    saveSearchToStore() {
      this.$store.commit('setDmRecordsSearch', { offlineSearchType: this.offlineSearchType, offlineSearchText: this.offlineSearchText });
    },

  }
}
